import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";
import { DropdownItem } from "@similarweb/ui-components";

export const StyledDDItemWrapper = styled(DropdownItem)`
    display: block;
    padding: 8px;
    height: auto;

    &:hover {
        background-color: transparent !important;
    }
`;

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    justify-content: center;
`;
